import type { Project, DocVer } from './types';

export const GENDOCS: Record<string, { title: string; seal?: boolean }> = {
  rule: { title: '개인투자조합 규약' },
  plan: { title: '조합 결성계획서' },
  expert: { title: '전문성 보유요건 확인서', seal: true },
  privacy: { title: '개인신용정보 동의서(GP)', seal: true },
  roster: { title: '조합원 명부' },
  lease: { title: '무상 임대차계약서' },
  bizreg: { title: '사업자등록 신청서' },
  inkam: { title: '조합인감등록부' },
  bankguide: { title: '조합명의 계좌 개설 은행 구비서류 안내장' },   // 2026-10-31 — 대표 · 조합명 · 출자금 · 법인 이체액 자동
  admininfo: { title: 'GP 행정정보 공동이용 사전동의서', seal: true },
  regform: { title: '개인투자조합 등록신청서', seal: true },
  minutes: { title: '결성총회 의사록', seal: true },
  jeungpyo: { title: '출자증표', seal: true },
  lpprivacy: { title: 'LP 개인정보 수집·이용·제공 동의서' },
};

export function orgName(p: Project): string {
  return (p.master && p.master.org) ? p.master.org : (p.org || '조합');
}
export function genFileName(p: Project, key: string, ext: string): string {
  return GENDOCS[key].title + '_' + orgName(p) + '.' + ext;
}
export function autoV1(p: Project, key: string): DocVer {
  return { label: '자동 생성 v1', doc: genFileName(p, key, 'docx'), pdf: genFileName(p, key, 'pdf'), kind: 'auto' };
}
/** 시안 ensureDocVer 충실: 저장본 없거나 자동v1 하나뿐이면 현재 조합명으로 갱신해 반환 */
export function getVers(p: Project, key: string): DocVer[] {
  const dv = p.docver && p.docver[key];
  if (dv && dv.length) {
    // 자동 v1이라도 S3 저장본이 있으면 실물이다 — 예전엔 무조건 placeholder 로 바꿔
    // 「미생성」으로 보이고 첫 열람에 다시 생성돼 v2가 쌓였다 (changedoc.ts 와 같은 가드)
    if (dv.length === 1 && dv[0].kind === 'auto' && !dv[0].s3doc && !dv[0].s3pdf) return [autoV1(p, key)];
    return dv;
  }
  return [autoV1(p, key)];
}
export function pdfNameOf(file: string): string {
  return file.replace(/\.(docx?|hwpx?|pdf)$/i, '') + '.pdf';
}

export const RELS: string[] = ['배우자', '자녀', '부모', '형제자매', '기타'];
